(function () {
  'use strict';
 
  function reveal(root) {
    var els = (root || document).querySelectorAll('.mb-returns [data-step]:not(.mb-in)');
    if (!els.length) return;
 
    // Sem IntersectionObserver: mostra tudo já.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('mb-in');
      return;
    }
 
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, i) {
        if (!en.isIntersecting) return;
        setTimeout(function () { en.target.classList.add('mb-in'); }, i * 90);
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
 
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }
 
  function init() {
    reveal(document);
 
    // Rede de segurança: se por alguma razão o observer não disparar
    // (elemento fora de ecrã, tema com transform no container, etc.),
    // ao fim de 2s mostra tudo à mesma. Melhor visível do que invisível.
    setTimeout(function () {
      var stuck = document.querySelectorAll('.mb-returns [data-step]:not(.mb-in)');
      for (var i = 0; i < stuck.length; i++) {
        var r = stuck[i].getBoundingClientRect();
        if (r.top < window.innerHeight) stuck[i].classList.add('mb-in');
      }
    }, 2000);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Editor do tema Shopify: re-corre quando a secção é recarregada.
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();